module.exports = __webpack_public_path__ + "images/home/signup-guide-arrow@2x-37bbe92636e0eb9073a60d1b84473c7b.png";